import React from 'react';

import { ScreenTitle } from '../../../../components/atoms';
import { TutorialSlider } from '../../../../components';
import './style.scss';

const Tutorial = () => {
  return (
    <>
      <div className='tutorial_slider'>
        <ScreenTitle title='Dashboard' subTitle='Tutorial'/>
        <TutorialSlider
          showLogo={false} Style={{
          width: '100%',
          padding: '0px 0px 35px 0px',
          height: 'auto',
          overflow: 'hidden',
          opacity: 0.99,
        }}
        />
      </div>
    </>
  );
};

export default Tutorial;
